module.exports = __webpack_public_path__ + "static/media/img-account.0ec7e7c2.jpg";